import React, { useEffect, useRef } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "../styles/Stepbystep.css";

import centerImage1 from "../assets/logo12.png";
import turnkeyIcon from "../assets/Turnkey Excellence.png";
import growthIcon from "../assets/Rapid Growth.png";
import expertiseIcon from "../assets/Decade of Expertise.png";
import solutionIcon from "../assets/Total Solution.png";
import servicesIcon from "../assets/More Services.png";
import greenIcon from "../assets/Green Ventures.png";
import milestoneIcon from "../assets/Impressive Milestone.png";
import gif1 from "../assets/gif1.gif";

const steps = [
  { label: "Turnkey Excellence", color: "#2f3e5d", icon: turnkeyIcon, i: -2 },
  { label: "Rapid Growth", color: "#2ca8e2", icon: growthIcon, i: -1 },
  { label: "Decade of Expertise", color: "#e23e30", icon: expertiseIcon, i: 0 },
  { label: "Total Solution", color: "#f29111", icon: solutionIcon, i: 1 },
  { label: "More Services", color: "#69b34c", icon: servicesIcon, i: 2 },
  { label: "Green Ventures", color: "#7c4dff", icon: greenIcon, i: 3 },
  { label: "Impressive Milestone", color: "#00bcd4", icon: milestoneIcon, i: 4 },
];

const carouselSlides = [
  { title: "• Turnkey Excellence:", description: "Mastering Power, Oil & Gas, Infrastructure, and Solar Energy." },
  { title: "• Rapid Growth", description: "From a 2013 Dubai startup to a DEWA-enlisted, world-class EPC provider." },
  { title: "• Decade of Expertise:", description: "Bringing cutting-edge, cost-effective practices to power systems." },
  { title: "• Total Solutions:", description: "Comprehensive services from design to commissioning for 11kV to 400kV substations." },
  { title: "• More Services:", description: "Substation ETC and O&M, equipment rental, and skilled workforce outsourcing." },
  { title: "• Green Ventures:", description: "Leading the way in Solar Energy projects across the UAE and GCC since 2023." },
  { title: "• Impressive Milestone:", description: "A thriving AED 150 million company, driven by 200 experts delivering seamless EPC projects." },
];

const Stepbystep = () => {
  const itemsRef = useRef([]);
  const degreeRef = useRef(0);
  const rotationRef = useRef(0);
  const zRef = useRef(0);
  const intervalRef = useRef(null);

  useEffect(() => {
    AOS.init({ duration: 1000 });

    const init = () => {
      const items = itemsRef.current;
      const length = items.length;
      const itemHeight = items[0]?.offsetHeight || 25;
      rotationRef.current = 360 / length;
      zRef.current = Math.round(itemHeight / 2 / Math.tan(Math.PI / length));
      updatePositions();
    };

    const updatePositions = () => {
      const degree = degreeRef.current;
      const rotation = rotationRef.current;
      const z = zRef.current;
      itemsRef.current.forEach((item, i) => {
        item.style.transform = `rotateX(${(i + degree) * rotation}deg) translateZ(${z}px)`;
      });
    };

    intervalRef.current = setInterval(() => {
      degreeRef.current += 1;
      updatePositions();
    }, 2500);

    window.addEventListener("resize", init);
    init();

    let isDragging = false;
    let startY = 0;
    let currentDegree = degreeRef.current;

    const handleMouseDown = (e) => {
      isDragging = true;
      startY = e.clientY;
      currentDegree = degreeRef.current;
      clearInterval(intervalRef.current);
    };

    const handleMouseMove = (e) => {
      if (!isDragging) return;
      const deltaY = e.clientY - startY;
      const deltaDegree = Math.round(deltaY / 10);
      degreeRef.current = currentDegree + deltaDegree;
      updatePositions();
    };

    const handleMouseUp = () => {
      if (isDragging) {
        isDragging = false;
        currentDegree = degreeRef.current;
        intervalRef.current = setInterval(() => {
          degreeRef.current += 1;
          updatePositions();
        }, 2500);
      }
    };

    const carouselEl = document.querySelector(".vcarousel");
    if (carouselEl) {
      carouselEl.addEventListener("mousedown", handleMouseDown);
      window.addEventListener("mousemove", handleMouseMove);
      window.addEventListener("mouseup", handleMouseUp);
    }

    return () => {
      clearInterval(intervalRef.current);
      window.removeEventListener("resize", init);
      if (carouselEl) {
        carouselEl.removeEventListener("mousedown", handleMouseDown);
        window.removeEventListener("mousemove", handleMouseMove);
        window.removeEventListener("mouseup", handleMouseUp);
      }
    };
  }, []);

  return (
    <div className="stepbystep-wrapper">
      <div className="stepbystep-container">
        <h2 className="main-heading">
          Our <span>Methodology</span>
        </h2>
        <div className="stepbystep-grid">
          {/* LEFT: Star Diagram */}
          <div className="star-diagram" data-aos="fade-right">
            <div className="center-image1">
              <img src={centerImage1} alt="Center Logo" />
            </div>
            {steps.map((step, index) => (
              <div
                key={index}
                className="star-segment"
                style={{
                  "--i": step.i,
                  "--color": step.color,
                }}
              >
                <div className="step-number">Step {index + 1}</div>
                <div className="icon">
                  <img src={step.icon} alt={step.label} />
                </div>
                <div className="text">{step.label}</div>
              </div>
            ))}
          </div>

          {/* RIGHT: Carousel */}
          <main className="vcarousel">
            {carouselSlides.map((slide, i) => (
              <div
                className="vcarousel-item"
                key={i}
                ref={(el) => (itemsRef.current[i] = el)}
              >
                <h3>{slide.title}</h3>
                <p>{slide.description}</p>
              </div>
            ))}
            <div className="vcarousel-gif">
              <img src={gif1} alt="Rotating Carousel Visual" />
            </div>
          </main>
        </div>
      </div>
    </div>
  );
};

export default Stepbystep;
